<template>
<div class="right-fixed">
    <a href="#first-floor" class="anchor-link">精彩推荐</a>
    <a href="#second-floor" class="anchor-link">活动说明</a>
    <a href="#third-floor" class="anchor-link">精选作品</a>
    <div class="qr-code"><img src="https://media7.imgyb.xyz/media/v1/image/aba210b3f0dface219dfedc49263cdc1.png" alt=""></div>
    <div class="note">马上加入活动专属群</div>
</div>
</template>
<script>
export default {
    name:'RightFixed',

}
</script>
<style lang="less" scoped>
.right-fixed{
    position: fixed; z-index: 5; left: 50%; bottom: 100px; width: 150px; margin-left: 500px; padding:41px 10px 53px; background: url(https://media6.imgyb.xyz/media/v1/image/df43e42ac4ab0a5989b3f6167c4ceacc.png) no-repeat left top, url(https://media2.imgyb.xyz/media/v1/image/a011d9c55ab388d975b20a4afece5b08.png) no-repeat right bottom, #fff3e1; border-radius: 8px; overflow: hidden;
    .anchor-link{display: block; font-size: 16px; line-height: 36px; color: #000; text-align: center;}
    .qr-code{
        img{margin: 15px auto 5px; display: block;}
    }
    .note{text-align: center; font-size: 13px; line-height: 18px;}
}
</style>